import React from "react";
import i18n from '../i18n';
import "flag-icons/css/flag-icons.min.css";

const LanguageSelector = () => {
    const chooseLanguage = (language) => {
        i18n.changeLanguage(language);
    }

    const languages = Object.keys(i18n.options.resources).sort();

    return (
        <div>
            {languages.map((language) => (
                <span
                    key={language}
                    className={`flag-icon p-1 me-2`}
                    onClick={() => chooseLanguage(language)}
                >
                    <span className={`fi fi-${language === 'en' ? 'gb' : language}`}></span>
                </span>
            ))}
        </div>
    );
};

export default LanguageSelector;
